import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['Lucía Fernández', 'Martín Rodríguez', 'Sofía Gómez', 'Diego Pérez', 'Camila Sánchez', 'Mariano López', 'Valeria Díaz', 'Federico Ruiz', 'Florencia Castro', 'Joaquín Méndez', 'Agustina Romero', 'Nicolás Torres'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bariloche', 'Bahía Blanca', 'Santa Fe', 'San Juan', 'Posadas', 'Resistencia'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      // Hide after 6 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Then repeat every 20-30 seconds
    const intervalTimer = setInterval(() => {
      showPopup();
    }, 25000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-175">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-6 left-6 z-50 w-80 bg-white rounded-xl shadow-2xl border border-slate-100 overflow-hidden" data-id="element-176">
          {/* Green Top Bar */}
          <div className="bg-green-600 px-4 py-1.5 flex items-center justify-between" data-id="element-177">
            <div className="flex items-center gap-1.5 text-white text-xs font-semibold tracking-wide" data-id="element-178">
              <CheckCircle2 className="w-3.5 h-3.5" data-id="element-179" />
              COMPRA VERIFICADA
            </div>
            <button onClick={() => setIsVisible(false)} className="text-white/80 hover:text-white transition-colors" data-id="element-180">
              <X className="w-4 h-4" data-id="element-181" />
            </button>
          </div>

          {/* Body */}
          <div className="p-4 flex items-start gap-4" data-id="element-182">
            <div className="w-12 h-12 bg-indigo-50 rounded-lg flex items-center justify-center flex-shrink-0 border border-indigo-100" data-id="element-183">
              <img src="https://cdn.magicpatterns.com/uploads/rgaVDBVW1QpFFPj37RZS9X/Diseno_sin_titulo_(30).png" alt="Kit Insomnio" className="w-10 h-10 object-contain" data-id="element-184" />
            </div>
            <div data-id="element-185">
              <p className="text-sm text-slate-800 leading-snug" data-id="element-186">
                <span className="font-bold" data-id="element-187">{currentData.name}</span> de{' '}
                {currentData.city} acaba de comprar el KIT Psicología del
                Insomnio™.
              </p>
              <p className="text-xs text-slate-500 mt-1" data-id="element-188">Hace unos minutos</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}